module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp3_5012.144d1289.png";